module.exports = __webpack_public_path__ + "img/habanero.07c68854.svg";